export default __webpack_public_path__ + "static/media/pdf.9b2b323b.png";